//
// JobParameter.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./JobParameterType";
import "./JobParameterDataType";
import "../common/values/AbstractValueType";

var JobParameter = createModule("BIRD::JobParameter", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        xref: 7,
        dataType: 4,
        name: 7,
        type: 4,
        value: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default JobParameter;
